import { Controller } from '@hotwired/stimulus'

// "Agregar tarea" opens into a search and Escape folds it back. Whenever the results frame changes,
// the focus goes where the next keystroke belongs: a package's questions when its picker is
// showing, otherwise the search, because planners add several products in a row.
export default class extends Controller {
  static targets = ['trigger', 'panel', 'input']
  static values = { frame: String }

  open () {
    this.triggerTarget.classList.add('hidden')
    this.panelTarget.classList.remove('hidden')
    this.inputTarget.focus()
  }

  close () {
    if (!this.isOpen) return

    this.panelTarget.classList.add('hidden')
    this.triggerTarget.classList.remove('hidden')
    this.triggerTarget.focus()
  }

  // 🔴 After the stream RENDERS, not on `turbo:submit-end`: Turbo renders a stream action a repaint
  // after it arrives, so focusing on submit-end found the old picker, which the stream then removed
  // — and the focus fell to <body>. Only streams aimed at this frame count; a stepper press on a row
  // must not pull the focus into the search.
  refocusAfterStreamRender (event) {
    if (event.target.getAttribute('target') !== this.frameValue) return

    const render = event.detail.render
    event.detail.render = async (stream) => {
      await render(stream)
      this.refocus()
    }
  }

  refocus () {
    if (!this.isOpen) return

    const question = this.panelTarget.querySelector('[data-choice-picker] select')
    if (question) {
      question.focus()
    } else if (document.activeElement !== this.inputTarget) {
      this.inputTarget.focus()
    }
  }

  get isOpen () {
    return !this.panelTarget.classList.contains('hidden')
  }
}
